import { Link } from 'react-router-dom'

export default function Empty({
  title,
  message,
  action,
}: {
  title: string
  message?: string
  action?: { label: string; to?: string; onClick?: () => void }
}) {
  return (
    <div
      className="panel stack"
      style={{ alignItems: 'center', textAlign: 'center', padding: '46px 24px', gap: 10 }}
    >
      <h2 className="t-display-s">{title}</h2>
      {message && (
        <p className="t-caption" style={{ maxWidth: 380 }}>
          {message}
        </p>
      )}
      {action &&
        (action.to ? (
          <Link className="btn btn-primary" to={action.to} style={{ marginTop: 6 }}>
            {action.label}
          </Link>
        ) : (
          <button className="btn btn-primary" style={{ marginTop: 6 }} onClick={action.onClick}>
            {action.label}
          </button>
        ))}
    </div>
  )
}
